import { GUDHUB_SETTINGS } from '../../../../gudhub_settings.js';

export const emailDataFetchMixin = {

    //********************* FETCH ACCOUNTS ********************************//
    // The active user's linked mailboxes (secrets never included - see
    // EmailDatabase.listAccountsByUser).
    async fetchAccounts() {
        const res = await fetch(`${GUDHUB_SETTINGS.conversation_server_url}/email/accounts?user_id=${this.activeUserId}`);
        if(!res.ok) return [];
        return res.json();
    },

    //********************* FETCH INBOX ********************************//
    // Latest message per thread for the active account, newest first.
    // * opts.q (string, optional) — free-text search (subject/body/from)
    async fetchInbox(opts = {}) {
        if(!this.activeAccountId) return [];

        const params = new URLSearchParams({ user_id: this.activeUserId, account_id: this.activeAccountId });
        if(opts.q) params.set('q', opts.q);

        const res = await fetch(`${GUDHUB_SETTINGS.conversation_server_url}/email/inbox?${params.toString()}`);
        if(!res.ok) return [];
        return res.json();
    },

    //********************* FETCH THREAD ********************************//
    // Full thread, oldest message first.
    // * threadKey (string)
    async fetchThread(threadKey) {
        const res = await fetch(`${GUDHUB_SETTINGS.conversation_server_url}/email/thread/${encodeURIComponent(threadKey)}?user_id=${this.activeUserId}`);
        if(!res.ok) return [];
        return res.json();
    },

    //********************* MARK READ ********************************//
    // * messageId (string)
    async markMessageRead(messageId) {
        await fetch(`${GUDHUB_SETTINGS.conversation_server_url}/email/message/${messageId}/read`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ user_id: this.activeUserId })
        });
    },

    //********************* SEND EMAIL ********************************//
    // * options.to/cc (string) — comma-separated addresses
    // * options.subject/html (string)
    // * options.attachments (Array<{filename, name}>) — bare stored filenames from uploadAttachment
    // * options.inReplyTo (string, optional) — rfc822 message id being replied to
    // * options.references (Array<string>, optional)
    async sendEmail({ to, cc, subject, html, attachments = [], inReplyTo, references }) {
        const res = await fetch(`${GUDHUB_SETTINGS.conversation_server_url}/email/accounts/${this.activeAccountId}/send`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                to: to.split(',').map(a => a.trim()).filter(Boolean),
                cc: cc ? cc.split(',').map(a => a.trim()).filter(Boolean) : undefined,
                subject, html,
                attachments,
                in_reply_to: inReplyTo,
                references
            })
        });

        if(!res.ok) {
            const err = await res.json().catch(() => ({}));
            throw new Error(err.message || 'Failed to send email');
        }

        return res.json();
    },

    //********************* UPLOAD ATTACHMENT ********************************//
    // Uploads a compose attachment, scoped to the active account's own folder.
    // Returns { filename, original_name, mime_type, size, ... } (see FileManager.uploadFile).
    // * file (File)
    async uploadAttachment(file) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('user_id', this.activeUserId);
        formData.append('account_id', this.activeAccountId);

        const res = await fetch(`${GUDHUB_SETTINGS.conversation_server_url}/email/attachments/upload`, {
            method: 'POST',
            body: formData
        });

        return res.json();
    },

};
